/* Essence Drawermenu
copyright 2016, Essence Webservice Ryo Inagaki
http://essencews.com
https://ryo0702.github.io/essence-drawermenu/
released under the MIT license
*/

;(function($) {

    var drawermenu = '#NavDrawer';
    var status = false;
    var menu_position = 'left';
      
    


    $(document).on("click",'.toggle-child',function(){
      if($(this).closest('.mobile-nav__has-sublist').next(".sub__menu_wrap").hasClass('is--active')){
          $(this).closest('.mobile-nav__has-sublist').next(".sub__menu_wrap").removeClass('is--active');
        $(this).removeClass('show');
      }else{
         $(".mobile-nav__toggle").removeClass('show');
         $(".sub__menu_wrap").removeClass('is--active');
         $(this).closest('.mobile-nav__has-sublist').next(".sub__menu_wrap").addClass('is--active');
        $(this).addClass('show');
      }
     
    });
  $(document).on("click",'.toggle-child-child',function(){
   
      if($(this).closest('.mobile-nav__has-sublist').next(".sub__menu_wrap").hasClass('is--active')){
          $(this).closest('.mobile-nav__has-sublist').next(".sub__menu_wrap").removeClass('is--active');
        $(this).removeClass('show');
      }else{
         $(this).closest('.mobile-nav__sublist').find(".mobile-nav__toggle").removeClass('show');
         $(this).closest('.mobile-nav__sublist').find(".sub__menu_wrap").removeClass('is--active');
         $(this).closest('.mobile-nav__has-sublist').next(".sub__menu_wrap").addClass('is--active');
        $(this).addClass('show');
      }
     
    });
    $(document).on("click",'.js-drawer-open-left',function(){
      if(status == false){
        $('body').addClass('js-drawer-open').addClass(' js-drawer-open-'+menu_position);
       $('html').addClass('js-drawer-open').addClass(' js-drawer-open-'+menu_position);
        status = true;
      }
      else{
        $('body').removeClass('js-drawer-open').removeClass(' js-drawer-open-'+menu_position);
       $('html').removeClass('js-drawer-open').removeClass(' js-drawer-open-'+menu_position);
        status = false;
      }
    });

    $(document).on("click",'.js-drawer-open-left .js-off-canvas-overlay',function(){
     if(status == false){
        $('body').addClass('js-drawer-open').addClass(' js-drawer-open-'+menu_position);
       $('html').addClass('js-drawer-open').addClass(' js-drawer-open-'+menu_position);
        status = true;
      }
      else{
        $('body').removeClass('js-drawer-open').removeClass(' js-drawer-open-'+menu_position);
       $('html').removeClass('js-drawer-open').removeClass(' js-drawer-open-'+menu_position);
        status = false;
      }
    });
   

})(jQuery);